<template>
  <v-btn
    :href="href"
    text
    target="_blank"
    class="link-button"
    :ripple="false"
    plain
    :data-tooltip="tooltipText"
  >
    {{ name }}
    <v-icon>mdi-open-in-new</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    href: { type: String, required: true },
    tooltipText: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.link-button {
  color: $tealBright !important;
  font-size: 1rem;
  position: relative;
  opacity: 1 !important;

  .v-icon {
    margin-left: 5px;
  }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    background: lighten($tealLighter, 10%);
    color: $black;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.25s ease;
  }

  &[data-tooltip=""]::after {
    display: none;
  }

  &:hover::after {
    opacity: 1;
  }
}
</style>
<style lang="scss">
.link-button {
  .v-btn__content {
    opacity: 1 !important;
  }
}
</style>
